import DestinationPushesSpotlight from '@zeus/core/drilldownTables/DestinationPushesSpotlight';
import React, { ReactElement } from 'react';

function DeliveryPushesSpotlight(): ReactElement {
  return <DestinationPushesSpotlight />;
}

export default DeliveryPushesSpotlight;
